export default {
  meta: {
    title: '开放页面-需求详情'
  }
};
